import { Divider, Pagination, Table, Tag } from "antd";
import { useEffect, useState } from "react";

import { FormOutlined } from "@ant-design/icons";

import { useNavigate } from "react-router-dom";

import { getContent } from "./ContentApi";
function Content() {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPages] = useState();
  const [ContentData, setContentData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  function FetchContentData() {
    setIsLoading(true);
    getContent(
      `?limit=10&page=${currentPage}${
        search && search.length ? `&search=${search}` : ""
      }`
    )
      .then((response) => {
        if (response.success) {
          setIsLoading(false);
          setContentData(response.data.items);
          setTotalPages(response?.data?.pagination?.lastPage);
          setCurrentPage(response?.data?.pagination?.currentPage);
        }
      })
      .catch((err) => {
        console.log("error", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    FetchContentData();
  }, [currentPage]);

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      className: " font-dmsans text-sm",
      render: (data, record) => (
        <p className="text-xs font-dmsans items-center flex justify-center">
          {record.title}
        </p>
      ),
    },
    {
      title: "Slug",
      dataIndex: "slug",
      key: "slug",
      className: " font-dmsans text-sm",
      render: (data, record) => (
        <p className="text-xs font-dmsans items-center flex justify-center">
          {record.slug}
        </p>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      className: " font-dmsans text-sm",
      render: (data, record) => (
        <p className="text-xs font-dmsans items-center flex justify-center">
          {record.type}
        </p>
      ),
    },
    {
      title: "Sport",
      dataIndex: "sport",
      key: "sport",
      className: " font-dmsans text-sm",
      render: (data, record) => (
        <p className="text-xs font-dmsans items-center flex justify-center">
          {record.sport}
        </p>
      ),
    },
    {
      title: "Status",
      dataIndex: "isUpdated",
      key: "isUpdated",
      align: "center",
      className: "font-dmsans text-sm",
      render: (data) => {
        return (
          <div className="flex justify-center">
            <Tag
              className={`text-xs font-dmsans items-center flex justify-center ${
                data
                  ? "bg-[#996600] text-white border-none p-1 w-[80px]"
                  : "bg-[#cecdcd] text-white border-none p-1 w-[80px]"
              }`}
            >
              {data ? "Updated" : "Pending"}
            </Tag>
          </div>
        );
      },
    },
    {
      title: "Edit",
      dataIndex: "edit",
      key: "edit",
      className: " font-dmsans text-sm",
      render: (data, record) => (
        <div className="items-center flex justify-center ">
          <FormOutlined
            title="Edit"
            className=" font-bold cursor-pointer text-lg text-[#616161] h-[18px] w-4"
            onClick={() =>
              navigate("/Content/addContent", {
                state: {
                  fill: record,
                  from: "edit",
                },
              })
            }
          />
        </div>
      ),
    },
  ];

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
  };

  return (
    <>
      <div className="ml-2  mt-6 mr-2">
        <div className=" mb-8 ">
          <Divider
            orientation="left"
            style={{ border: "#cecece" }}
            className="text-base tracking-normal font-dmsans font-normal  text-gray-900"
          >
            Content Details
          </Divider>
          <div className="flex justify-center items-center gap-3">
            <input
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              type="text"
              placeholder="Type to search... "
              onChange={(e) => setSearch(e.target.value)}
            />
            <button
              class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              type="button"
              onClick={FetchContentData}
            >
              Search
            </button>
          </div>
        </div>

        <div
          style={{ maxHeight: "620px", overflow: "auto" }}
          className="bg-white"
        >
          <Table
            columns={columns}
            dataSource={ContentData}
            className="w-screen sm:w-screen"
            loading={isLoading}
            pagination={false}
          />
        </div>
        <Pagination
          className="mt-2  flex justify-center items-center font-inter font-medium text-base w-full  h-[19px] "
          onChange={handlePageChange}
          current={currentPage}
          defaultCurrent={1}
          total={10 * totalPage}
          showSizeChanger={false}
        />
      </div>
    </>
  );
}
export default Content;
